import React, { useState } from "react";
import { Flex } from "@chakra-ui/react";
import { Text } from "@foleon/atomic";
import SmileyOld from "../icons/SmileyOld";
import { writeDocReview } from "../../../utils/services/surveyService";
import { useParams } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

const MEGA_SAD = 1;
const SAD = 2;
const NEUTRAL = 3;
const HAPPY = 4;
const MEGA_HAPPY = 5;

const NOT_REVIEWED = -1;

export const SmileysContainerOld = () => {
	const [currentValue, setCurrentValue] = useState(NOT_REVIEWED);
	const [selected, setSelected] = useState(false);
	const params = useParams();

	const saveReview = (review: number) => {
		if (selected) return;
		setSelected(true);
		setCurrentValue(review);

		const uniqueID = uuidv4();
		const docId = params["publicationId"];
		const name = params["name"];
		if (docId && name)
			writeDocReview(uniqueID, +docId, name, review);
	};

	return (
		<Flex
			direction="column"
			alignItems="center"
			gap="24px"
			pt="8px"
			pb="8px"
		>
			<Text.Title style={{ marginBottom: "0px", textAlign: "center" }}>
				{selected ? "Thanks for your input!" :
					"How would you rate this content?"}
			</Text.Title>

			<Flex
				direction="row"
				justifyContent="center"
				flexWrap="wrap"
				gap={{ base: "10px", sm: "20px" }}
			>
				<SmileyOld
					isSelected={selected}
					smileyValue={MEGA_SAD}
					currentValue={currentValue}
					saveReview={saveReview}
					src="mega-sad.svg"
					alt="Mega Sad Smiley"
				/>
				<SmileyOld
					isSelected={selected}
					smileyValue={SAD}
					currentValue={currentValue}
					saveReview={saveReview}
					src="sad.svg"
					alt="Sad Smiley"
				/>
				<SmileyOld
					isSelected={selected}
					smileyValue={NEUTRAL}
					currentValue={currentValue}
					saveReview={saveReview}
					src="neutral.svg"
					alt="Neutral Smiley"
				/>
				<SmileyOld
					isSelected={selected}
					smileyValue={HAPPY}
					currentValue={currentValue}
					saveReview={saveReview}
					src="happy.svg"
					alt="Happy Smiley"
				/>
				<SmileyOld
					isSelected={selected}
					smileyValue={MEGA_HAPPY}
					currentValue={currentValue}
					saveReview={saveReview}
					src="mega-happy.svg"
					alt="Mega Happy Smiley"
				/>
			</Flex>
		</Flex>
	);
};

export default SmileysContainerOld;